// eslint-disable-next-line custom/no-restricted-imports
import { find } from 'ramda';
import type { SagaIterator } from 'redux-saga';
import { select } from 'redux-saga/effects';
import { Language } from '@core/internationalize/models/language';
import { toLocale } from '@core/internationalize/models/locale';
import type { Locale } from '@core/internationalize/models/locale';
import { getDisplayLanguage } from '@engage/settings/redux';

export type LanguageAnalyticsProps = {
  deviceLanguage: Language;
  deviceLocale: Locale;
};

export const getLanguageAnalyticsPropsSaga = function* (): SagaIterator {
  const language = yield select(getDisplayLanguage);
  return {
    deviceLanguage: toLanguageName(language),
    deviceLocale: toLocale(language),
  };
};

const toLanguageName = (language: Language) =>
  // @ts-expect-error (TS7053): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'typeof Language'
  find(key => language === Language[key], Object.keys(Language));
